import { useEffect, useState } from 'react'
import { useClerk, useAuth } from '@clerk/clerk-react'

export default function AdminGuard({ children }: { children: React.ReactNode }) {
  const { signOut } = useClerk()
  const { getToken } = useAuth()
  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null)
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    async function checkWhitelist() {
      try {
        const token = await getToken()
        const res = await fetch(`${import.meta.env.VITE_API_BASE ?? ''}/api/admin/me`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })

        if (res.ok) {
          setIsAuthorized(true)
        } else {
          setErrorMsg('Access Denied: Your account is not whitelisted for this CMS.')
          // Delay signout slightly so the error message renders
          setTimeout(() => signOut(), 100)
        }
      } catch (err) {
        setErrorMsg('Access Denied: Could not verify authorization.')
        setTimeout(() => signOut(), 100)
      }
    }
    checkWhitelist()
  }, [signOut, getToken])

  if (errorMsg) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bg-default)',
        color: '#f87171',
        padding: '2rem',
        textAlign: 'center',
        flexDirection: 'column',
        gap: '1rem'
      }}>
        <h2>⛔ {errorMsg}</h2>
        <p>You have been signed out.</p>
      </div>
    )
  }

  if (isAuthorized === null) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        background: 'var(--bg-default)',
        color: 'var(--text-muted)'
      }}>
        <h2>Verifying access... 🔒</h2>
      </div>
    )
  }

  return <>{children}</>
}
